export default [
  {
    path: "/xsjh",
    name: "xsjh",
    component: (resolve) => require(["@/views/PCView/xsjh/index.vue"], resolve),
  },
];
